/* eslint-disable */
import React from 'react';
import toastr from 'toastr';
import Env from '../../Helpers/env';
import { fetchData } from '../../Helpers/services/Api';

class PayHubButton extends React.Component {
  handlePayBtnClick = async () => {
    const authUser = localStorage.getItem('auth_user');
const parsedAuthUser = authUser ? JSON.parse(authUser) : {};
const token = parsedAuthUser.token;
// const role = parsedAuthUser.roles || [];
    const headers = {
      'Content-Type': 'application/json',
      Authorization: token,
    };

    const baseUrl = Env.env.REACT_APP_BACKEND_BASE_URL_V3;
    const url = `${baseUrl}/getpaymentdetails/redirection-url`;

    try {
      const response = await fetchData(url, {
        method: 'GET',
        headers,
      });

      if (response.ok) {
        const data = response ? await response.json() : {};
        window.open(data.redirectionUrl, '_blank');
      } else {
        toastr.error(
          'Failed to fetch payment details. Please try again later.'
        );
      }
    } catch (error) {
      console.error('Error fetching payment details:', error);
      toastr.error(
        'An error occurred while processing your request. Please try again.'
      );
    }
  };

  render() {
    const { userRole, isDashboardPath } = this.props;
    const isPayHubEnabled = Env.env.ENV === 'prod';

    const shouldRenderButton =
      isPayHubEnabled &&
      (userRole === 'CUSTOMERADMIN' || userRole === 'CSSUPPORT') &&
      isDashboardPath;

    return shouldRenderButton ? (
      <button
        className="payHubBtn"
        onClick={this.handlePayBtnClick}
        disabled={userRole === 'ROOTADMIN' || userRole === 'CSSUPPORT'}
      >
        PayHub
      </button>
    ) : null;
  }
}

export default PayHubButton;
